// import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core'
// import { Store } from '@ngrx/store'
// import { selectUserPermissions } from '../store/auth/auth.selectors'
// import { AuthState } from '../store/auth/auth.state'
// import { take } from 'rxjs'
// import { getStoredPermissions } from '../utils/permission.helper'

// @Directive({
//   selector: '[appHasPermission]',
//   standalone: true
// })
// export class HasPermissionDirective {
//   private store = inject(Store)
//   private userPermissions$ = this.store.select(selectUserPermissions)

//   constructor(
//     private templateRef: TemplateRef<unknown>,
//     private viewContainer: ViewContainerRef
//   ) {}

//   //before 7 may 2026
//   // @Input('appHasPermission') set hasPermission(
//   //   requiredPermissions: Record<string, string[]> | Record<string, string[]>[]
//   // ) {
//   //   this.userPermissions$.pipe(take(1)).subscribe(userPermissions => {
//   //     const permissions = userPermissions as Record<string, string[]>
//   //     const required = Array.isArray(requiredPermissions)
//   //       ? requiredPermissions
//   //       : [requiredPermissions]
//   //     this.updateView(permissions, required)
//   //   })
//   // }

//   // private updateView(
//   //   userPermissions: NonNullable<AuthState['user']>['userRole']['permissions'],
//   //   requiredPermissionsArray: Record<string, string[]>[]
//   // ) {
//   //   const hasPermission = requiredPermissionsArray.some(requiredPermission =>
//   //     Object.entries(requiredPermission).every(([entity, actions]) =>
//   //       actions.every(action => userPermissions[entity]?.includes(action))
//   //     )
//   //   )

//   //   if (hasPermission) {
//   //     if (this.viewContainer.length === 0) {
//   //       this.viewContainer.createEmbeddedView(this.templateRef)
//   //     }
//   //   } else {
//   //     this.viewContainer.clear()
//   //   }
//   // }

//   //7 may 2026
//   // @Input('appHasPermission') set hasPermission(
//   //   requiredPermissions: Record<string, string[]> | Record<string, string[]>[]
//   // ) {
//   //   const permissions = getStoredPermissions()

//   //   console.log('🔐 LOCAL PERMISSIONS (Directive):', permissions)
//   //   console.log('📌 REQUIRED:', requiredPermissions)

//   //   const hasActions = (module: string, actions: string[]) => {
//   //     const userActions = permissions[module] || []
//   //     return actions.every(a => userActions.includes(a))
//   //   }

//   //   const required = Array.isArray(requiredPermissions)
//   //     ? requiredPermissions
//   //     : [requiredPermissions]

//   //   const hasPermission = required.some(set =>
//   //     Object.entries(set).every(([module, actions]) => hasActions(module, actions as string[]))
//   //   )

//   //   this.viewContainer.clear()

//   //   if (hasPermission) {
//   //     this.viewContainer.createEmbeddedView(this.templateRef)
//   //   }
//   // }

//   @Input('appHasPermission') set hasPermission(
//     requiredPermissions: Record<string, string[]> | Record<string, string[]>[]
//   ) {
//     const userPermissions = this.getUserPermissions()

//     const required = Array.isArray(requiredPermissions)
//       ? requiredPermissions
//       : [requiredPermissions]
//     // console.log('USER PERMISSIONS:', userPermissions)
//     // console.log('REQUIRED:', required)
//     // this.updateView(userPermissions, required)

//     const hasPermission = this.checkPermission(userPermissions, required)

//     this.updateView(hasPermission)
//   }

//   private updateView(hasPermission: boolean) {
//     this.viewContainer.clear()

//     if (hasPermission) {
//       this.viewContainer.createEmbeddedView(this.templateRef)
//     }
//   }

//   private getUserPermissions(): Record<string, string[]> {
//     const raw = localStorage.getItem('permissions')
//     if (!raw) return {}

//     const parsed = JSON.parse(raw)

//     const map: Record<string, string[]> = {}

//     parsed.forEach((item: any) => {
//       map[item.moduleName] = item.permissions || []
//     })

//     return map
//   }

//   private checkPermission(
//     userPermissions: Record<string, string[]>,
//     requiredPermissionsArray: Record<string, string[]>[]
//   ): boolean {
//     return requiredPermissionsArray.some(requiredPermission =>
//       Object.entries(requiredPermission).every(([module, actions]) =>
//         actions.every(action => userPermissions[module]?.includes(action))
//       )
//     )
//   }
// }

//8 may 2026
import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectUserPermissions } from '../store/auth/auth.selectors'
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs'

// @Directive({
//   selector: '[appHasPermission]',
//   standalone: true,
//   exportAs: 'hasPermission'
// })
// export class HasPermissionDirective implements OnDestroy {
//   private destroy$ = new Subject<void>()

//   private requiredPermissions: Record<string, string[]> | Record<string, string[]>[] = {}

//   private latestPermissions: Record<string, string[]> = {}
//   public hasAccess = false
//   constructor(
//     private store: Store,
//     private templateRef: TemplateRef<any>,
//     private viewContainer: ViewContainerRef
//   ) {
//     // 🔥 ONE TIME SUBSCRIPTION ONLY
//     this.store
//       .select(selectUserPermissions)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(perms => {
//         this.latestPermissions = this.normalize(perms)
//         this.render()
//       })
//   }

//   @Input('appHasPermission')
//   set setPermissions(value: Record<string, string[]> | Record<string, string[]>[]) {
//     this.requiredPermissions = value || {}
//     this.render()
//   }

//   private render() {
//     const required = Array.isArray(this.requiredPermissions)
//       ? this.requiredPermissions
//       : [this.requiredPermissions]

//     this.hasAccess = required.some(set =>
//       Object.entries(set).every(([module, actions]) =>
//         actions.every(action => this.latestPermissions[module]?.includes(action))
//       )
//     )

//     this.viewContainer.clear()

//     if (this.hasAccess) {
//       this.viewContainer.createEmbeddedView(this.templateRef)
//     }
//   }

//   private normalize(perms: any): Record<string, string[]> {
//     const map: Record<string, string[]> = {}

//     if (!perms) return map

//     if (Array.isArray(perms)) {
//       perms.forEach(p => {
//         if (p?.moduleName) {
//           map[p.moduleName] = p.permissions || []
//         }
//       })
//     } else {
//       Object.assign(map, perms)
//     }

//     return map
//   }

//   ngOnDestroy() {
//     this.destroy$.next()
//     this.destroy$.complete()
//   }
// }

//3 aug 2026 gps
@Directive({
  selector: '[appHasPermission]',
  standalone: true,
  exportAs: 'hasPermission'
})
export class HasPermissionDirective implements OnDestroy {
  private destroy$ = new Subject<void>()
  private requiredPermissions: Record<string, string[]> | Record<string, string[]>[] = {}
  private latestPermissions: Record<string, string[]> = {}
  private viewCreated = false // 👈 naya: track karo view already bana hai ya nahi
  public hasAccess = false

  constructor(
    private store: Store,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    // this.store
    //   .select(selectUserPermissions)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(perms => {
    //     this.latestPermissions = this.normalize(perms)
    //     this.render()
    //   })

    this.store
      .select(selectUserPermissions)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)), // 👈 content-based comparison
        takeUntil(this.destroy$)
      )
      .subscribe(perms => {
        this.latestPermissions = this.normalize(perms)
        this.render()
      })
  }

  @Input('appHasPermission')
  set setPermissions(value: Record<string, string[]> | Record<string, string[]>[]) {
    this.requiredPermissions = value || {}
    this.render()
  }

  private render() {
    const required = Array.isArray(this.requiredPermissions)
      ? this.requiredPermissions
      : [this.requiredPermissions]

    const newAccess = required.some(set =>
      Object.entries(set).every(([module, actions]) =>
        actions.every(action => this.latestPermissions[module]?.includes(action))
      )
    )

    // 🔥 SIRF TABHI DOM touch karo jab access value actually change ho
    if (newAccess === this.hasAccess && this.viewCreated === newAccess) {
      return // kuch nahi badla, DOM ko haath mat lagao
    }

    this.hasAccess = newAccess
    this.viewContainer.clear()

    if (this.hasAccess) {
      this.viewContainer.createEmbeddedView(this.templateRef)
      this.viewCreated = true
    } else {
      this.viewCreated = false
    }
  }

  private normalize(perms: any): Record<string, string[]> {
    const map: Record<string, string[]> = {}
    if (!perms) return map
    if (Array.isArray(perms)) {
      perms.forEach(p => {
        if (p?.moduleName) {
          map[p.moduleName] = p.permissions || []
        }
      })
    } else {
      Object.assign(map, perms)
    }
    return map
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
